module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "menu-box"
  }, [_c('div', {
    staticClass: "menu-wrap content-padded section-white content-box clearfix"
  }, [_c('div', {
    staticClass: "menu_preview_area"
  }, [_c('div', {
    staticClass: "mobile_menu_preview"
  }, [_c('div', {
    staticClass: "mobile_hd tc"
  }, [_vm._v("ONex平台")]), _vm._v(" "), _c('div', {
    staticClass: "mobile_bd"
  }, [_c('ul', {
    staticClass: "pre_menu_list grid_line ui-sortable ui-sortable-disabled",
    class: {
      'no_menu': _vm.menuData.length === 0
    }
  }, [_vm._l((_vm.menuData), function(item, index) {
    return _c('li', {
      staticClass: "pre_menu_item grid_item grid_item selected size1of2",
      class: item.id === _vm.id && !_vm.cid ? 'current' : item.id === _vm.id && _vm.cid ? '' : 'no_extra',
      on: {
        "click": function($event) {
          return _vm.chooseMenu(item.id, index)
        }
      }
    }, [_c('input', {
      attrs: {
        "type": "hidden",
        "name": "parentmenu"
      },
      domProps: {
        "value": index
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "pre_menu_link",
      attrs: {
        "href": "javascript:;"
      }
    }, [(_vm.menuData.length <= 0) ? _c('i', {
      staticClass: "el-icon-plus"
    }) : _vm._e(), _c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), (item.second_menu !== undefined) ? _c('div', {
      staticClass: "sub_pre_menu_box"
    }, [_c('ul', {
      staticClass: "sub_pre_menu_list"
    }, [_vm._l((item.second_menu), function(subItem, subIndex) {
      return _c('li', {
        class: subItem.id === _vm.cid ? 'current' : '',
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.chooseSubMenu(subItem.id, index, subIndex)
          }
        }
      }, [_c('input', {
        attrs: {
          "type": "hidden",
          "name": "submenu"
        },
        domProps: {
          "value": index + '-' + subIndex
        }
      }), _vm._v(" "), _c('a', {
        attrs: {
          "href": "javascript:;"
        }
      }, [_c('span', {
        staticClass: "sub_pre_menu_inner"
      }, [_vm._v(_vm._s(subItem.name))])])])
    }), _vm._v(" "), (item.second_menu.length < 5) ? _c('li', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.addSubMenu.apply(null, arguments)
        }
      }
    }, [_vm._m(0, true)])]) : _vm._e()], 2)]) : _vm._e()])
  }), _vm._v(" "), (_vm.menuData.length < 3) ? _c('li', {
    staticClass: "js_addMenuBox pre_menu_item grid_item no_extra size1of2"
  }, [_c('a', {
    staticClass: "pre_menu_link",
    attrs: {
      "href": "javascript:;",
      "title": "最多添加4个一级菜单"
    },
    on: {
      "click": _vm.addMenu
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), (_vm.menuData.length === 0) ? _c('span', [_vm._v("添加菜单")]) : _vm._e()])]) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "content-box-right"
  }, [_c('div', {
    staticClass: "editor-box"
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_c('h3', [_vm._v("菜单名称")]), _vm._v(" "), (_vm.id !== null) ? _c('a', {
    staticClass: "fr link",
    staticStyle: {
      "margin-top": "-30px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removemenu.apply(null, arguments)
      }
    }
  }, [_vm._v("删除菜单")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [(!_vm.isChild) ? _vm._l((_vm.menuData), function(item, index) {
    return (item.id === _vm.id) ? _c('el-form', {
      key: item.id,
      attrs: {
        "label-width": "90px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "菜单名称"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "240px"
      },
      attrs: {
        "maxlength": 4
      },
      model: {
        value: (item.name),
        callback: function($$v) {
          _vm.$set(item, "name", $$v)
        },
        expression: "item.name"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "form-text-tip"
    }, [_vm._v("字数不超过4个字")])], 1), _vm._v(" "), (item.second_menu === undefined || item.second_menu.length === 0) ? [_c('el-form-item', {
      attrs: {
        "label": "菜单内容"
      }
    }, [_c('el-radio-group', {
      model: {
        value: (item.menu_type),
        callback: function($$v) {
          _vm.$set(item, "menu_type", $$v)
        },
        expression: "item.menu_type"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": 1
      }
    }, [_vm._v("发送消息")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 2
      }
    }, [_vm._v("跳转网页")])], 1)], 1), _vm._v(" "), _c('el-form-item', [(item.menu_type == 1) ? _c('MsgSender', {
      attrs: {
        "type": item.news_type
      },
      on: {
        "change": _vm.updateMsg
      },
      model: {
        value: (item.content),
        callback: function($$v) {
          _vm.$set(item, "content", $$v)
        },
        expression: "item.content"
      }
    }) : _vm._e(), _vm._v(" "), (item.menu_type == 2) ? _c('div', {
      staticClass: "menu_content"
    }, [_c('p', {
      staticClass: "frm-tips"
    }, [_vm._v("订阅者点击该子菜单会跳到以下链接")]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }, [_c('span', {
      staticClass: "label f_l",
      staticStyle: {
        "display": "block",
        "padding-right": "10px"
      }
    }, [_vm._v("页面地址")]), _vm._v(" "), _c('div', {
      staticClass: "f_l content_mar_l"
    }, [_c('el-input', {
      staticStyle: {
        "width": "300px"
      },
      model: {
        value: (item.url),
        callback: function($$v) {
          _vm.$set(item, "url", $$v)
        },
        expression: "item.url"
      }
    })], 1)])]) : _vm._e()], 1)] : _vm._e()], 2) : _vm._e()
  }) : _vm._l((_vm.menuData[_vm.id].second_menu), function(item, index) {
    return (_vm.menuData[_vm.id].second_menu && item.id === _vm.cid) ? _c('el-form', {
      key: item.id,
      attrs: {
        "label-width": "90px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "菜单名称"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "240px"
      },
      attrs: {
        "maxlength": 4
      },
      model: {
        value: (item.name),
        callback: function($$v) {
          _vm.$set(item, "name", $$v)
        },
        expression: "item.name"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "form-text-tip"
    }, [_vm._v("字数不超过4个字")])], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "菜单内容"
      }
    }, [_c('el-radio-group', {
      model: {
        value: (item.menu_type),
        callback: function($$v) {
          _vm.$set(item, "menu_type", $$v)
        },
        expression: "item.menu_type"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": 1
      }
    }, [_vm._v("发送消息")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 2
      }
    }, [_vm._v("跳转网页")])], 1)], 1), _vm._v(" "), _c('el-form-item', [(item.menu_type == 1) ? _c('MsgSender', {
      attrs: {
        "type": item.news_type
      },
      on: {
        "change": _vm.updateMsg
      },
      model: {
        value: (item.content),
        callback: function($$v) {
          _vm.$set(item, "content", $$v)
        },
        expression: "item.content"
      }
    }) : _vm._e(), _vm._v(" "), (item.menu_type == 2) ? _c('div', {
      staticClass: "menu_content"
    }, [_c('p', {
      staticClass: "frm-tips"
    }, [_vm._v("订阅者点击该子菜单会跳到以下链接")]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }, [_c('span', {
      staticClass: "label f_l",
      staticStyle: {
        "display": "block",
        "padding-right": "10px"
      }
    }, [_vm._v("页面地址")]), _vm._v(" "), _c('div', {
      staticClass: "f_l content_mar_l"
    }, [_c('el-input', {
      staticStyle: {
        "width": "300px"
      },
      model: {
        value: (item.url),
        callback: function($$v) {
          _vm.$set(item, "url", $$v)
        },
        expression: "item.url"
      }
    })], 1)])]) : _vm._e()], 1)], 1) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border tc"
  }, [(_vm.id !== null) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("保存并发布至微信")]) : _vm._e()], 1)])])]), _vm._v(" "), _c('TWXXSelect', {
    attrs: {
      "twxx-visible": _vm.twxxVisible,
      "show-history": true
    },
    on: {
      "chooseTW": _vm.chooseTWAction,
      "closeTWDialog": _vm.closeTWDialogAction
    }
  }), _vm._v(" "), _c('WbApp', {
    attrs: {
      "app-visible": _vm.appVisisble
    },
    on: {
      "chooseApp": _vm.chooseAppAction,
      "closeTWDialog": _vm.closeAppDialogAction
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "sub_pre_menu_inner"
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e5447024", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5447024"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/brand/wechat/custommenu.vue
// module id = 2957
// module chunks = 0